<template>
  <div>
    <h2 class="primary--text font-weight-bold pt-5 pl-2">
      {{ $t('display/offer:create.regions') }}
    </h2>
    <v-btn
      class="ma-2"
      outlined
      @click="() => allRegion = !allRegion"
      color="primary"
    >
      {{getRegionSwitchText()}}
    </v-btn>
    <v-treeview
      selectable
      item-disabled="locked"
      :items="translatedRegion"
      item-text="name"
      item-value="id"
      v-model="model"
    />
  </div>
</template>

<script>
import Utils from '@/modules/core/services/utils';
import AdvertService from '@/modules/display/services/advert-service';

export default {
  name: "RegionsComponent",
  data() {
    return {
      regions: [],
      rawRegions: [],
      globalCityCount: 0,
      provinceCount: new Map(),
      model: [],
      allRegion: true,
      allSelectedCities: []
    }

  },
  computed: {
    translatedRegion() {
      if (this.regions.length === 0) return [];
      let translatedRegions = [];

      for (let i = 0; i < this.regions.length; i++) {
        let translatedRegion = {
          id: this.regions[i].id,
          name: this.$t(`country:${this.regions[i].name}.country`)
        };

        let provinces = this.regions[i].children;
        let translatedProvinces = [];
        for (let j = 0; j < provinces.length; j++) {
          let translatedProvince = {
            id: provinces[j].id,
            name: this.$t(`country:${this.regions[i].name}.provinces.${provinces[j].name}`),
            children: provinces[j].children,
            count: provinces[j].count
          }
          translatedProvinces.push(translatedProvince);
        }
        translatedRegion.children = translatedProvinces;
        translatedRegion.count = this.regions[i].count;
        translatedRegions.push(translatedRegion)
      }

      return translatedRegions;
    }
  },
  created() {
    AdvertService.readAllRegionsCount(
      (response) => {
        this.rawRegions = response.data;
        for (var i = 0; i < response.data.length; i++) {
          let country =
            Object.assign(
            {
              id: response.data[i].country_id,
              name: response.data[i].country_name.toLowerCase()
            },
            this.getCountryProvinces(response.data[i]));
          this.regions.push(country);
        }
        if (this.allRegion) {
          this.model = this.allSelectedCities;
        }
      },
      () => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/offer:snackbar.regions')}));
      }
    )
  },
  methods: {
    getCountryProvinces(country) {
      if (typeof country.provinces === 'undefined') {
        return {};
      }

      let provinces = [];
      let provincesCityCount = 0;
      for (let i = 0; i < country.provinces.length; i++) {
        let provinceCities = this.getCities(country.provinces[i]);
        provincesCityCount += provinceCities.count;
        provinces.push(
          Object.assign(
            {
              id: country.provinces[i].province_id,
              name: country.provinces[i].province_name.toLowerCase().replace(' ', '-')
            },
            provinceCities
          )
        );
      }

      return {
        children: provinces,
        count: provincesCityCount
      }
    },

    getCities(province) {
      if (typeof province.city_counts === 'undefined') {
        return {};
      }

      let cities = [];
      let cityCount = 0;
      for (let i = 0; i < province.city_counts.length; i++) {
        cities.push({
          id: `${province.province_id}#${province.city_counts[i].city_name}`,
          name: `${province.city_counts[i].city_name} (${province.city_counts[i].count})`
        });
        this.allSelectedCities.push(`${province.province_id}#${province.city_counts[i].city_name}`);
        this.globalCityCount++;
        cityCount++;
      }
      let result = {
        children: cities,
        count: cityCount
      };

      this.provinceCount.set(province.province_id, cityCount);

      return result;
    },

    updateFilterFlag(regions) {

      for (let i = 0; i < regions.length; i++) {
        if (this.isFullCountry(regions[i].provinces, regions[i].country_id)) {
          regions[i].filter_flag = 1;
          regions[i].provinces = [];
        }
      }

      return regions;
    },

    isFullCountry(provinces, countryId) {
      let isFullCountry = provinces.length === this.getProvinceCountByCountryId(countryId);

      for(let i = 0; i < provinces.length; i++) {
        let provinceCount = this.provinceCount.get(provinces[i].province_id);
        if (provinceCount === provinces[i].cities.length) {
          provinces[i].cities = [];
          provinces[i].filter_flag = 1;
        } else {
          isFullCountry = false;
        }
      }

      return isFullCountry && provinces.length > 0;
    },

    getProvinceCountByCountryId(countryId) {
      for(let i = 0; i < this.rawRegions.length; i++) {
        if (countryId === this.rawRegions[i].country_id) {
          return this.rawRegions[i].provinces.length;
        }
      }
    },

    getRegionStructureForFilter(cities) {
      let region = [];
      for(let i = 0; i < cities.length; i++) {
        let cityData = cities[i].split('#');
        region = this.mergeTwoStructure(region, this.getProvinceStructure(cityData[0], cityData[1]));
      }

     return this.updateFilterFlag(region);
    },

    getProvinceStructure(provinceId, city) {
      for (let countryIt = 0; countryIt < this.rawRegions.length; countryIt++) {
        let provinces = this.rawRegions[countryIt].provinces;
        for(let provinceIt = 0; provinceIt < provinces.length; provinceIt++) {
          let province = provinces[provinceIt];
          if (province.province_id == provinceId) {
            let country = {
              country_id: this.rawRegions[countryIt].country_id,
              country_name: this.rawRegions[countryIt].country_name,
              filter_flag: 0
            };
            let resultProvince = {
              filter_flag: 0,
              province_id: province.province_id,
              province_name: province.province_name,
              cities: [city]
            }
            country.provinces = [resultProvince];
            return [country];
          }
        }
      }
    },

    mergeTwoStructure(obj1, obj2) {
      for (let attr in obj2) {
        if (typeof obj1[attr] === 'undefined') {
          obj1[attr] = obj2[attr];
        } else if(obj1[attr].country_id === obj2[attr].country_id) {
          obj1[attr].provinces = this.mergeProvinces(obj1[attr].provinces, obj2[attr].provinces)
        } else {
          obj1.push(obj2[attr]);
        }
      }

      return obj1;

    },

    mergeProvinces(provinces1, provinces2) {
      for (let i = 0; i < provinces2.length; i++) {
        if (typeof provinces1[i] === 'undefined') {
          provinces1[i] = provinces2[i];
        } else if( provinces1[i].province_id == provinces2[i].province_id) {
          provinces1[i].cities = [].concat(provinces1[i].cities, provinces2[i].cities);
          provinces1[i].filter_flag = provinces2[i].filter_flag;
          provinces1[i].province_id = provinces2[i].province_id;
        } else {
          provinces1.push(provinces2[i]);
        }
      }
      return provinces1;
    },
    getRegionSwitchText() {
      if (this.allRegion) {
        return this.$t('buttons:deselect-all');
      } else  {
        return this.$t('buttons:select-all');
      }
    },

    clear() {
      this.model = this.allSelectedCities;
    }
  },
  watch: {
    model() {
      let region = this.getRegionStructureForFilter(this.model);
      this.$emit('regionUpdated', region);
      if (region.length === 0) {
        this.allRegion = false;
      } else if (this.model.length === this.allSelectedCities.length) {
        this.allRegion = true;
      }
    },
    allRegion() {
      if (this.allRegion) {
        this.model = this.allSelectedCities;
      } else {
        this.model = [];
      }
    }
  }
}
</script>